module.exports = __webpack_public_path__ + "img/icon_team.5cd6355e.svg";